import { useState } from "react";
import axios from 'axios';
import { useLocation } from "react-router-dom";
import CandidateHeader from '../Candidate/Candidate Navbar/Header';
import jsPDF from 'jspdf';
import { useNavigate } from 'react-router-dom';
import certificate from './Certificate.png';
import ExamNavbar from "./ExamNavbar";
import certheme from '../../assets/exam/certhemes.png'




export default function Certificate() {
    const location = useLocation();
    let navigate = useNavigate();
    const exam = location.state.exam;
    const percentage = location.state.percentage;
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
  
    const[errors, setErrors] = useState({});

    const [input,setInput] = useState({
        first_name:"",
        email:"",
        phone:""
    });


    const handleChange = (e) => {
        setInput({...input,[e.target.name]:e.target.value});
        setErrors( { ...errors, [e.target.name]: "" });
    }

    function validation(input) {
        let errors = {}
        const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        var status = true;
    
    
        if (input.first_name === "") {
            status = false;
            errors.first_name = "Please enter your name";
        }
    
        if (input.email === "") {
            status = false;
            errors.email = "Please enter your email address"
        }
    
        if (input.phone === "") {
            status = false;
            errors.phone = "Please enter your phone number"
        }
    
    
        if (input.phone && (input.phone.length < 10  || input.phone.length > 10)) {
            status = false;
            errors.phone = "Phone number must have 10 numbers"
        }
    
        if (input.email && !email_pattern.test(input.email)) {
            status = false;
            errors.email = "Please enter a valid email address"
        }
    
        return {'errors':errors,'status':status};
    }

    const handleGeneratePdf = () => {

        const validationstatus = validation(input)
        if (!validationstatus.status) {
            setErrors(validationstatus.errors);
        }
        else{
            axios.post("https://sheetdb.io/api/v1/f86jr0p4950q8",{
                Name: input.first_name,
                Email: input.email,
                Phone: input.phone,
                Source: exam.name,
                Date: date
            }).then(res => {
                console.log(res.data)
            })

            const doc = new jsPDF('l', 'px', 'a4', 'false');
            doc.addImage(certificate, 'PNG', 0, 0, 632, 447)
            doc.setFont('times', 'bold')
            doc.setFontSize(30);
            doc.text(45, 190, input.first_name)
            doc.text(45, 250, exam.name)
            doc.setFontSize(13);
            doc.setTextColor('#334166');
            doc.text(233, 305.6, date)
            doc.setFontSize(14);
            doc.text(127, 344, input.phone)
            doc.text(145, 361.5, percentage + '%')
            doc.save('Certificate')

            navigate('/skill-test')
        }

    };

//prevent form submitting
function handleSubmit(e) {
    e.preventDefault();
}


return (
    <section>
         <CandidateHeader />
         <ExamNavbar />

<div className="container" > 
    <div
        className="cetificate-container my-5 px-4 pt-4 "
        style={{ boxShadow: "0px 0px 3px 0px #c1c1c1" , maxWidth:"850px", margin:"0 auto"}} >
        <h5 className='text-center  mb-0  mb-md-3'>Please fill your details to get Certificate </h5>
        <div className="row">
                <div className="col-12 col-md-6 text-center">
                  <img src={certheme} alt="" width="300px" height="300px"  />
                </div>
                <div className="col-md-6">
                <form className='form'  onSubmit={handleSubmit}>
                    <div className="form-group cer-from-group">
                    <label htmlFor="first_name" 
                    className="form-label text-start">Name<span style={{color: "#D5C6B8",fontWeight:"lighter"}}>*</span>
                    </label>
                    <input
                    type="text"
                    name="first_name"
                    className="form-control "
                    placeholder="Enter your Full Name"
                    onChange={handleChange} 
                    id="name"/>
                    <span className="cer-error-msg">
                    {errors.first_name ? errors.first_name : ""}
                    </span>
                    </div>
                    <div className="form-group cer-from-group">
                    <label htmlFor="email" 
                    className="form-label text-start">Email<span style={{color: "#D5C6B8",fontWeight:"lighter"}}>*</span>
                    </label>
                    <input
                    type="email"
                    name="email"
                    className="form-control "
                    placeholder="Enter your Email"
                    onChange={handleChange} 
                    id="email"/>
                    <span className="cer-error-msg">
                    {errors.email ? errors.email : ""}
                    </span>
                    </div>
                    <div className="form-group cer-from-group">
                    <label htmlFor="phone" 
                    className="form-label text-start">Phone Number<span style={{color: "#D5C6B8",fontWeight:"lighter"}}>*</span>
                    </label>
                    <input
                    type="number"
                    name="phone"
                    className="form-control "
                    placeholder="Enter your Phone Number"
                    onChange={handleChange} 
                    id="phone"/>
                    <span className="cer-error-msg">
                    {errors.phone ? errors.phone : ""}
                    </span>
                    </div>
                   
                    <div className="text-center my-4">
                    <button className="btn btn-success exam-btn" 
                        onClick={()=>handleGeneratePdf()}>Download</button>
                    </div>
                </form>
                </div>
                </div>
    </div>
      </div>
    </section>
)
}